import { render, staticRenderFns } from "./NamespacesOverview.vue?vue&type=template&id=11fe24be&scoped=true"
import script from "./NamespacesOverview.vue?vue&type=script&lang=js"
export * from "./NamespacesOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fe24be",
  null
  
)

export default component.exports